import { Component, OnInit, Input, Output, EventEmitter, HostListener, ViewEncapsulation, Renderer2 } from '@angular/core';
import { REDEEM_TYPE, getLottieConfig, SCRATCH_CARDS } from 'src/app/core/constants/app-constants';
import { AccountService } from 'src/app/modules/account/service/account.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService, AppData } from '../..';
import { ErrorMessage } from 'src/app/core/constants/validation-msg-constants';
import { copyTextToClipboard, getShareMessage } from '../../utils/common-functions';
import { ScratchCard, SCRATCH_TYPE } from 'scratchcard-js';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';
import { ActivatedRoute, Router } from '@angular/router';
import { WebIntentService } from "../../services/web-intent.service";
import { Clipboard } from '@ionic-native/clipboard/ngx';
import { AudioPlayerService } from "../../services/audio-player.service";

@Component({
  selector: 'app-scratch-card-modal',
  templateUrl: './scratch-card-modal.component.html',
  styleUrls: ['./scratch-card-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ScratchCardModalComponent implements OnInit {
  @Input() modalObj;
  @Output() currentCardObj: EventEmitter<any> = new EventEmitter();

  redeemType = REDEEM_TYPE;

  lottieConfigCopy = [
    // getLottieConfig('CARD_EARN_CONFIG'),
    getLottieConfig('SUCCESS_CONFIG'),
    getLottieConfig('GIFT_REWARDS_CONFIG'),
  ];
  lottieConfig;
  orderNumber;
  scratchWon = false;
  scratchWonConfig = getLottieConfig("SCRATCH_WON_CONFIG");
  textToShow = '';
  navigateTo = ''
  scratchedImage = {
    'won': 'assets/scratch-cards/icons-on-card/scratched_card.png',
    'loose': 'assets/scratch-cards/icons-on-card/coin.png'
  }

  constructor(
    private accountService: AccountService,
    private activeModal: NgbActiveModal,
    private toast: ToastService,
    private socialSharing: SocialSharing,
    public webIntentService: WebIntentService,
    private router: Router,
    private clipboard: Clipboard,
    private audioService: AudioPlayerService,
    private activateRoute: ActivatedRoute,
    private renderer: Renderer2
  ) {
    this.lottieConfig = JSON.parse(JSON.stringify(this.lottieConfigCopy));
    this.lottieConfig[0].showConfig = true;
    this.activateRoute.queryParams.subscribe((params) => {
      this.navigateTo = params["redirectUrl"];
    });
  }

  ngOnInit() {
    console.log("modal obj ", this.modalObj)

    if (this.modalObj.enableCard) {
      setTimeout(() => {
        this.lottieConfig = JSON.parse(JSON.stringify(this.lottieConfigCopy));
        this.lottieConfig[1].showConfig = true;
      }, 3500);

      // setTimeout(() => {
      //   this.lottieConfig = JSON.parse(JSON.stringify(this.lottieConfigCopy));
      //   this.lottieConfig[2].showConfig = true;
      // }, 5000)
    }

    if (this.modalObj.scratchMessage === '') {
      this.modalObj.scratchMessage = 'Better Luck Next Time';
    }

    if (!this.modalObj.scratched && !this.modalObj.enableCard) {
      document.getElementById('wrapper').classList.add('d-block');
      setTimeout(() => {
        this.createNewScratchCard();
      }, 200);
    }

    if (this.modalObj.scratched) {
      document.getElementById('scratched-card').classList.add('d-block');
    }

    this.getOrderNum(this.modalObj.beforeEarnBy)
  }

  createNewScratchCard() {
    // const scContainer = document.getElementById('sc-container')
    const htmlBackground = `<div class="cardamountcss text-center background">
        <img src="${this.modalObj.image ? this.modalObj.image : ((!this.modalObj.image) && this.modalObj.amount && this.modalObj.amount > 0) ? this.scratchedImage['won'] : this.scratchedImage['loose']}" width="85%" />
        <div class='won-amnt'>${this.modalObj.scratchMessage}</div>
      </div>`;
    console.log(htmlBackground)
    const sc = new ScratchCard('#sc-container', {
      scratchType: SCRATCH_TYPE.CIRCLE,
      containerWidth: 220,
      containerHeight: 260,
      imageForwardSrc: 'assets/scratch-cards/scratch_card.png',
      // Uncomment the line below if you have a background image
      imageBackgroundSrc: 'assets/images/scratchcard-background.svg',
      htmlBackground: htmlBackground,
      clearZoneRadius: 30,
      percentToFinish: 4,
      nPoints: 10, // Example value; adjust as needed
      pointSize: 10, // Example values; adjust as needed
      brushSrc: null, // Set to null or path to a brush image if using a custom brush
      enabledPercentUpdate: true, // Enable or disable percent updates
      
      callback: () => {
        this.accountService.redeemScratchCard(this.modalObj.scratchId).then(() => {
          this.modalObj.scratched = true;
          this.currentCardObj.emit(this.modalObj);
          if (this.modalObj.amount > 0 || this.modalObj.redeemType === this.redeemType.THIRD_PARTY) {
            this.scratchWon = true;
            this.audioService.play();
            setTimeout(() => {
              this.scratchWon = false;
            }, 3000);
            setTimeout(() => {
              // document.getElementById('bottom-btn').classList.add('d-block');
            }, 500);
          } else {
            setTimeout(() => {
              this.activeModal.close();
            }, 500);
          }
        });
      }
    });    
    sc.init().then(() => {
      const scratchMessage = document.querySelector('.won-amnt')
      if (((!this.modalObj.image) && (this.modalObj.amount && this.modalObj.amount > 0))) {
        this.renderer.addClass(scratchMessage, 'scratch-view-init')
      } else if (((!this.modalObj.image) && !(this.modalObj.amount && this.modalObj.amount > 0))) {
        const cartAmountCss = document.querySelector('.cardamountcss');
        this.renderer.removeClass(cartAmountCss,'background')
        this.renderer.addClass(scratchMessage, 'better-luck-text')
      }
      sc.canvas.addEventListener('scratch.move', () => {
        let percent = sc.getPercent();

        // console.log(sc);
        // console.log(percent);
      });
    }).catch((err) => {
      console.log(err.message);
    });
  }

  onBottomButtonClick() {
    console.log('clicked');
    if (this.modalObj.action.clickEvent === 'url') {
      // window.open(this.modalObj.action.url, '_blank');
      this.webIntentService.openUrl(this.modalObj.action.url);
    } else if (this.modalObj.action.clickEvent === 'invite') {
      const textToShow = getShareMessage(AppData.userInfoData, this.modalObj.amount);

      console.log(AppData.userInfoData);
      console.log(textToShow);

      this.socialSharing.share(textToShow, 'YUMZY', null, '').then(() => {
        console.log('success');
      })
        .catch((err) => {
          alert('Sharing not possible');
        });
    }
  }

  copyCode() {
    console.log('copied');
    copyTextToClipboard(this.modalObj.action.couponCode, this.clipboard)
      .then(() => {
        this.toast.presentToast(ErrorMessage.CODE_COPIED_MSG, '', 'success');
      })
      .catch(() => {
        this.toast.presentToast(ErrorMessage.FAILED_TO_COPY_MSG, '', 'success');
      })
  }

  checkClassToCloseModal(classList) {
    const arrOfClass = classList.value.split(" ");
    return arrOfClass.some((obj) => obj === 'close-modal');
  }

  onClose() {
    this.activeModal.close();
  }

  @HostListener('document:click', ['$event']) clickout(event) {
    if (this.checkClassToCloseModal(event.target.classList)) {
      console.log('MODAL CLOSED');
      this.activeModal.close();
    }
  }

  onViewInfoNavigate(scratchCard) {
    const navigateTo = this.navigateTo;
    this.router.navigate(['scratch-info'], { queryParams: { redirectUrl: window.location.pathname, navigatefrom: this.navigateTo }, state: { data: { scratchCard } } });
    this.activeModal.close();
  }

  getOrderNum(orderText) {
    if (orderText) {
      let wordSplit = orderText.split(' ');
      this.orderNumber = Number(wordSplit.slice(6, 7));
      console.log("orderNumber ", this.orderNumber)
    }
  }
}
